import { Icons } from '@/assets/icons/icons';

type DetachFromParentButtonProps = {
  readonly onDetach: () => void;
};

const LABEL = 'Move out of the card above';

// Takes a card out from under the larger card it sits under, so it stands on its own in the Feed
export const DetachFromParentButton = ({
  onDetach,
}: DetachFromParentButtonProps) => (
  <button
    type="button"
    aria-label={LABEL}
    title={LABEL}
    data-testid="card-detach"
    onClick={onDetach}
    className="flex size-[calc(28*var(--ac-u))] items-center justify-center rounded-full text-foreground-subtle hover:bg-secondary-hover hover:text-foreground"
  >
    <Icons.unlink aria-hidden="true" className="size-[calc(14*var(--ac-u))]" />
  </button>
);
